import getItemViewAppliedLoyaltyUpgrade from 'checkout/lib/utils/loyalty/getItemViewAppliedLoyaltyUpgrade'
import getCheckoutLoyaltyItemsPriceInCurrency from 'checkout/selectors/loyalty/getCheckoutLoyaltyItemsPriceInCurrency'
import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import { isPrestige4nPromo } from 'checkout/constants/paymentPromotions'
import getAllItemViews from '../view/getAllItemViews'
import { isFlightItem } from 'lib/checkout/checkoutUtils'

function isClassicRewardFlightItem(item: App.Checkout.AnyItem) {
  return isFlightItem(item) && item.isClassicReward
}

const getCheckoutLoyaltyPointsBurnCalculationRequests = createSelector(
  (state: App.State) => state.checkout.cart.currencyCode || state.geo.currentCurrency,
  (state: App.State) => state.checkout.promo?.code,
  (state: App.State) => getAllItemViews(state),
  (state: App.State) => getCheckoutLoyaltyItemsPriceInCurrency(state),
  (
    currency,
    promoCode,
    allItemViews,
    itemsPriceInCurrency,
  ): Array<App.Checkout.LoyaltyPointBurnCalculationRequest> => {
    if (isPrestige4nPromo(promoCode)) return EmptyArray
    if (!allItemViews.hasRequiredData) return EmptyArray
    const requests: Array<App.Checkout.LoyaltyPointBurnCalculationRequest> = allItemViews.data.values().reduce<Array<App.Checkout.LoyaltyPointBurnCalculationRequest>>((acc, curr) => {
      const view = curr.data
      const pricing = itemsPriceInCurrency.get(view.item.itemId)
      if (view.loyalty.productType && pricing && !isClassicRewardFlightItem(view.item)) {
        const appliedLoyaltyUpgrade = getItemViewAppliedLoyaltyUpgrade(view)
        acc.push({
          item: view.item,
          currency,
          mx: appliedLoyaltyUpgrade?.targetPackage?.mx ?? view.loyalty.mx ?? view.mx,
          price: pricing.loyaltyUpgradeTargetPrice || pricing.price,
          productType: view.loyalty.productType,
          loyaltyGroupKey: view.loyalty.groupKey,
        })
      }
      return acc
    }, [])
    return requests
  },
)

export default getCheckoutLoyaltyPointsBurnCalculationRequests
